import { useState } from "react";
import {
  Button,
  Grid,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { downloadFilePost } from "../../services/ReportService";
import CardHeader from "../General/CardHeader";
import GlassCard from "../General/GlassCard";
import { useToast } from "../../context/ToastContext";

export default function FailedLegalFileReportByDate() {
  const { showToast } = useToast();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [loading, setLoading] = useState(false);

  const handleGenerateReport = async () => {
    if (!startDate || !endDate) {
      showToast("Debe completar ambas fechas para continuar.", "error")
      return;
    }
    if (startDate.isAfter(endDate)) {
      showToast(
        "La fecha de inicio no puede ser posterior a la fecha de fin.",
      "error")
      return;
    }

    setLoading(true);

    try {
      const payload = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
      };

      // Acá esperás un blob, como corresponde
      const response = await downloadFilePost("failed/file/report", payload);

      // Crear URL y descargar el archivo
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // Intentar obtener nombre del archivo desde headers
      const disposition = response.headers["content-disposition"];
      const filenameMatch = disposition?.match(/filename="(.+)"/);
      const filename = filenameMatch
        ? filenameMatch[1]
        : "reporte_operaciones.xlsx";

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast("Ocurrió un error al generar el reporte.", "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }}>
        <GlassCard>
            <CardHeader
              icon={<AssignmentIcon />}
              title="Reportes de Expedientes Fallidos"
              description="Genera un reporte de expedientes fallidos en el sistema."
            />

            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <DatePicker
                  label="Desde"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <DatePicker
                  label="Hasta"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleGenerateReport}
                 
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Generar Reporte"
                  )}
                </Button>
              </Grid>
            </Grid>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
